import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LoadingScreen from '../components/LoadingScreen';
import useToken from '../hooks/useToken';
import { networkVerifyToken } from '../network/auth';
import Login from '../pages/auth/Login';
import { PATH_AUTH } from '../routes/paths';
import useAdminInfoStore from '../store/admin';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const uToken = useToken();
  const { setAdminInfo } = useAdminInfoStore();

  const [isLoading, setIsLoading] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleSetAdminInfo = (adminInfo) => {
    setAdminInfo({
      ...adminInfo,
      Menu: adminInfo?.Menu?.reverse(),
    });
  };

  useEffect(() => {
    const onGetAdminInfo = async () => {
      setIsLoading(true);

      try {
        const token = await uToken.getToken();

        if (token) {
          if (pathname === PATH_AUTH.login) {
            navigate(-1);
          }
          const res = await networkVerifyToken(token);

          const adminInfo = res?.data?.items;

          handleSetAdminInfo(adminInfo);

          setIsAuthenticated(true);

          const defaultRoute = adminInfo?.Menu?.find((item) => item?.ProfileUACMenuIsDefaultRoute);

          if (pathname === '/dashboard/projects') {
            navigate(defaultRoute?.ProfileUACMenuUrl);
          } else if (pathname !== defaultRoute?.ProfileUACMenuUrl) {
            navigate(pathname + search);
          } else {
            navigate(defaultRoute?.ProfileUACMenuUrl);
          }
        } else {
          setIsLoading(false);
          navigate(PATH_AUTH.login);
        }
      } catch (error) {
        setIsLoading(false);
        setAdminInfo(null);
        uToken.removeToken();
        navigate(PATH_AUTH.login);
      } finally {
        setIsLoading(false);
      }
    };

    onGetAdminInfo();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return <>{children}</>;
}
